// extracted by mini-css-extract-plugin
export default {"wrap":"QuantityButton_wrap__wtD2-","number":"QuantityButton_number__tJroy","plus":"QuantityButton_plus__mB7uQ","minus":"QuantityButton_minus__4YQPE"};